var exports = {
  "iE": "xaf9ae18d--8655b7--wrapper",
  "Kk": "xaf9ae18d--8655b7--icon",
  "DD": "xaf9ae18d--8655b7--title",
  "iU": "xaf9ae18d--8655b7--message",
};

module.exports = exports;
